<div class="advyzon-callback">
  <ng-container *ngIf="!error; else errorState">
    <p>Signing you in&hellip;</p>
  </ng-container>
  <ng-template #errorState>
    <p>We couldn't complete your sign-in. Please try again from Advyzon, or</p>
    <button type="button" (click)="goToLogin()">go to the FiSpoke login page</button>.
  </ng-template>
</div>
